export const PERMISSION_ACTION_WRITE = 'write';
export const PERMISSION_ACTION_READ = 'read';
export const PERMISSION_ACTION_EXPORT = 'export';
export const PERMISSION_ACTION_DELETE = 'delete';
export const PERMISSION_ACTION_APPROVE = 'approve';
export const PERMISSION_ACTION_PUBLIC = 'public';
export const PERMISSION_ACTION_READ_ENCRYPTED = 'readEncrypted';
export const PERMISSION_ACTION_EXPORT_ENCRYPTED = 'exportEncrypted';
export const PERMISSION_ACTION_AGGREGATE = 'aggregate';
export const PERMISSION_ACTION_SYNC = 'sync';
